import React from 'react';
import { CaseStudyHighlightContentfulModel } from 'src/api/models/CaseStudyHighlight';
import CaseStudyHighlight from 'src/organisms/articles/caseStudies/caseStudies.highlight';
import styled, { css } from 'styled-components';

const DynamicCaseStudyHighlightContainer = styled.div<{ fontSize?: number }>`
  width: 100%;

  & > div {
    margin: 1rem 50px;
  }

  ${({ fontSize }) => !fontSize ? '' : css`
    div {
      font-size: ${fontSize}px;
    }
  `}
`

export default function getDynamicCaseStudyHighlight(caseStudyHighlightProps: CaseStudyHighlightContentfulModel): React.ReactNode {
  return (
    <DynamicCaseStudyHighlightContainer fontSize={caseStudyHighlightProps.fontSize}>
      <CaseStudyHighlight highlight={caseStudyHighlightProps.highlight} />
    </DynamicCaseStudyHighlightContainer>
  )
}
